<script lang="ts">
	import { onMount } from "svelte";

	export let token: string;
	let modalOpen = false;

	onMount(() => {
		import("$lib/vic.umd.cjs");
	});
</script>

<button
	class="fixed bottom-20 right-4 z-10 md:bottom-8 md:right-8"
	on:click={() => {
		modalOpen = true;
	}}
>
	<img alt="Converse com a VIC!" src="/img/avatar-vic.webp" />
</button>
<div
	class="modal fixed left-0 top-0 z-[100] flex h-screen w-screen items-center justify-center transition-opacity"
	class:hidden={!modalOpen}
>
	<button
		class="absolute h-full w-full bg-black opacity-40"
		on:click={() => {
			modalOpen = false;
		}}
	/>
	<chat-vic
		class="bg-transparent"
		data-answer-key="chatVic"
		data-token={token}
		data-url={`${new URL(import.meta.env.VITE_HASURA_HTTP_URI).origin}/api/rest/vic/chat`}
		on:close={() => {
			modalOpen = false;
		}}
	/>
</div>

<style>
	@keyframes fade-in-normal {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

	.modal {
		animation: fade-in-normal 350ms ease 0s 1 normal both;
	}
</style>
